"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var root_reducer_1 = require("./root.reducer");

exports.modulesReducer = root_reducer_1.modulesReducer;